import React from 'react';
import {
  Stack,
  Text,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Flex,
} from '@chakra-ui/react';
import Footer from '../Components/General/Footer';
import Navbar from '../Components/General/Navbar';
import ContentHeader from '../Components/General/ContentHeader';

export default function FAQ() {
  const uploadQA = [
    {
      question: 'Q：如何登入/註冊「化學署區塊鏈數位證書」？',
      answer:
        'A：請於首頁點擊【自然人憑證登入】，經由毒性及關注化學物質登記申報系統登入使用。',
    },
    {
      question: 'Q：「化學署區塊鏈數位證書」目前支援哪些證書種類？',
      answer:
        'A：目前僅支援【毒性化學物質核准證件】，未來將視使用情況與市場需求擴大應用範圍。',
    },
    {
      question: 'Q：如何使用「化學署區塊鏈數位證書」？',
      answer:
        'A：登入後系統將自動顯示貴公司持有的核准文件，可進行證書分享、查核與驗證等操作。',
    },
    {
      question: 'Q：如何驗證「化學署區塊鏈數位證書」的真實性？',
      answer:
        'A：本平台資料來源來自於毒性及關注化學物質資訊公開平台，並以聯盟鏈永久保存有關資料。\n使用者可透過取得的驗證連結，確認證書的真實性。',
    },
    {
      question: 'Q：如何取得「化學署區塊鏈數位證書」的驗證連結？',
      answer:
        'A：請向您的上下游有關廠商，索取【毒性化學物質核准證件】的分享連結，以查驗相關資訊。',
    },
    {
      question: 'Q：「化學署區塊鏈數位證書」是否有期限？',
      answer:
        'A：本平台僅能分享期限內之核可文件證書，使用期限與證書本身內容有關，例如廠商的證照有效期限等。\n使用者可透過本平台提供的查詢功能，獲取相關文件的有效期限資訊。',
    },
  ];
  const QACollpase = (props) => (
    <AccordionItem width="70vw">
      <h2>
        <AccordionButton display="flex" justifyContent="space-between">
          <Text fontSize="20px" fontWeight="bold">
            {props.question}
          </Text>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel pb={4}>
        {props.answer.split('\n').map((item, index) => (
          <Text key={index}>{item}</Text>
        ))}
      </AccordionPanel>
    </AccordionItem>
  );
  return (
    <Navbar>
      <Stack>
        <Stack minW="800px" spacing={5} mb={16} h="80vh" overflowY="scroll">
          <ContentHeader title="常見問題" />
          <Flex width="100vw" justifyContent="center">
            <Accordion marginTop="50px" allowMultiple>
              {uploadQA.map((qa) => (
                <QACollpase
                  key={qa.question}
                  question={qa.question}
                  answer={qa.answer}
                />
              ))}
            </Accordion>
          </Flex>
        </Stack>
        <Footer />
      </Stack>
    </Navbar>
  );
}
